import { Box, Flex, Grid, Text } from "@chakra-ui/react";
import { Button } from "components/button/Button";
import { Icon } from "components/icon/Icon";

export const ErrorPage = () => {
  return (
    <Grid backgroundColor="bg.default" minH="100vh" placeItems="center">
      <Flex direction="column" gap="2" textAlign="center">
        <Box m="0 auto 40px auto">
          <Icon name="status/Color/Error" size="48" fill="error.fg" />
        </Box>
        <Text textStyle="h1">Something went wrong</Text>
        <Text as="span" textStyle="subtitle4" mb="8">
          An unexpected error occurred. Reloading the page usually fixes it.
        </Text>
        <Flex gap="4" justifyContent="center">
          <Button
            onClick={() => window.location.reload()}
            w="183px"
            icon={<Icon name="elements/Database/Refresh" />}
          >
            Reload
          </Button>
          <Button
            as="a"
            w="183px"
            href="mailto:support@tigerdata.com"
            variant="secondary"
            icon={<Icon name="actions/Email" />}
          >
            Report the issue
          </Button>
        </Flex>
      </Flex>
    </Grid>
  );
};
